/**
 * Container Variants
 *
 * CVA variants for the Container component.
 * Exported separately to comply with React Fast Refresh requirements.
 *
 * @see Container.tsx for component implementation
 */

import {cva} from 'class-variance-authority';

export const containerVariants = cva("mx-auto w-full", {
  variants: {
    /**
     * Maximum width of the container
     * All values use Tailwind's built-in max-width classes (no arbitrary values)
     */
    size: {
      xs: "max-w-xs", // 320px - Very narrow (mobile forms)
      sm: "max-w-sm", // 384px - Small (modals)
      md: "max-w-md", // 448px - Medium (cards)
      lg: "max-w-lg", // 512px
      xl: "max-w-xl", // 576px
      "2xl": "max-w-2xl", // 672px
      "3xl": "max-w-3xl", // 768px
      "4xl": "max-w-4xl", // 896px - Good for content pages
      "5xl": "max-w-5xl", // 1024px
      "6xl": "max-w-6xl", // 1152px
      "7xl": "max-w-7xl", // 1280px - Wide layouts
      narrow: "max-w-2xl", // Alias for 2xl
      default: "max-w-5xl", // Alias for 5xl
      wide: "max-w-7xl", // Alias for 7xl
      full: "max-w-full", // No max width
      prose: "max-w-prose", // ~65ch - Optimal for reading
      screen: "max-w-screen-xl", // Screen-based
    },
    /**
     * Horizontal padding (responsive by default)
     * Uses Tailwind spacing scale tokens
     */
    padding: {
      none: "px-0",
      sm: "px-4 sm:px-6",
      md: "px-4 sm:px-6 lg:px-8",
      lg: "px-6 sm:px-8 lg:px-12",
      xl: "px-6 sm:px-10 lg:px-16",
    },
    /**
     * Vertical padding for section-like containers
     * Uses Tailwind spacing scale tokens
     */
    paddingY: {
      none: "py-0",
      sm: "py-4 sm:py-6",
      md: "py-6 sm:py-8 lg:py-12",
      lg: "py-8 sm:py-12 lg:py-16",
      xl: "py-12 sm:py-16 lg:py-24",
    },
    /**
     * Center content horizontally (text alignment)
     */
    center: {
      true: "text-center",
      false: "",
    },
  },
  defaultVariants: {
    size: "default",
    padding: "md",
    paddingY: "none",
    center: false,
  },
});
